<template>
  <div>
    <a
      class="btn btn-sm btn-success"
      data-target="#modalAddProductoPrecio"
      data-toggle="modal"
      href="#"
    >
      <i class="os-icon os-icon-ui-22"></i>
      <span>Nueva Linea de Credito</span>
    </a>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header smaller">
            <h5 class="modal-title">Nueva Linea de Credito</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <label>Numero de Tarjeta</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="current.id"
                  v-on:keyup.enter="guardar(current)"
                />
              </div>
              <div class="col-12">
                <br />
                <label>Estatus</label>
                <br />
                <input
                  type="checkbox"
                  name="1"
                  value="true"
                  v-model="current.estatus"
                  checked="checked"
                />
                &nbsp;
                <label for="1">¿activo?</label><br /><br />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="guardar(current)">Guardar</button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import Notifications from "@/notifications/notifications";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import LineaCreditoService from "@/services/cxc/LineaCreditoService";

export default {
  components: {
    ProductoSelectComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      posicion: "",
      current: {
        estatus: true,
        errors: {},
      },
    };
  },
  mounted() {},
  methods: {
    dateCurrent() {
      this.date = new Date();
      //Año
      this.y = this.date.getFullYear();
      //Mes
      this.m = this.date.getMonth() + 1;
      //Día
      this.d = this.date.getDate();
      this.date_current = this.d + "/" + this.m + "/" + this.y;
    },
    guardar(current) {
      let self = this;
      LineaCreditoService.save("cxc", "linea-credito", current)
        .then((response) => {
          Notifications.alert.success(
            "Crear Nueva Linea de Credito",
            "Se ha guardado la información"
          );
          self.$router.push({
            name: "cxc-linea_credito-editar",
            params: { id: response.data.id },
          });
          $("#modalAddProductoPrecio").modal("hide");
        })
        .catch((error) => {
          if (error.response.data.detail) {
            Notifications.alert.error(
              "Crear Nueva Linea de Credito",
              error.response.data.detail
            );
          }
          console.log(error.response.data.id[0]);
          if (error.response.data.id) {
            this.error = error.response.data.id[0];
            Notifications.alert.error("Crear Nueva Linea de Credito", this.error);
          }
        });
    },
    selectPosicion(current) {
      let self = this;
      DynamicService.fetch("cat", "tienda-posicion", {
        tienda: current.tienda,
      }).then((response) => {
        self.posicion = response.data.results;
      });
    },
  },
};
</script>
